import React, { useEffect, useState } from 'react'
import { Checkbox, Group, UnlabeledField } from '@common/ui'
import { com } from '@eidu/web'
import FieldValueEqualsInput from './FieldValueEqualsInput'
import { findEntityTypeByFieldId } from '../../util/EntityTypeExtensions'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import EntityType = com.eidu.entity.type.EntityType
import EntityTypeId = com.eidu.entity.type.EntityTypeId
import EntitySelector = com.eidu.entity.selector.EntitySelector

type EntitySelectorInputProps = {
  entityTypes: readonly EntityType[]
  entitySelector: EntitySelector
  setEntitySelector: (selector: EntitySelector) => void
  disabled?: boolean
}

const TargetSelectorInput: React.FC<EntitySelectorInputProps> = ({
  entityTypes,
  entitySelector,
  setEntitySelector,
  disabled = false,
}) => {
  const isDisabled = disabled
  const [filter, setFilter] = useState(entitySelector instanceof EntitySelector.FieldValueEquals)
  const [entityTypeId, setEntityTypeId] = useState<EntityTypeId | undefined>()

  useEffect(() => {
    if (entitySelector instanceof EntitySelector.OfType) {
      setFilter(false)
      setEntityTypeId(entitySelector.typeId)
    } else if (entitySelector instanceof EntitySelector.FieldValueEquals) {
      setFilter(true)
      const newEntityTypeId = findEntityTypeByFieldId(entityTypes, entitySelector.fieldId)
      if (newEntityTypeId) setEntityTypeId(newEntityTypeId.id)
    } else {
      throw new Error(`Unsupported entity selector type for TargetSelector: ${entitySelector}`)
    }
  }, [entitySelector])

  return (
    <Group gap="xs" align="flex-start" wrap="nowrap" p={8} style={{ flex: 1, minWidth: 0 }}>
      {entityTypes && (
        <div style={{ flexShrink: 0 }}>
          <EntityTypeField
            label="Type"
            types={entityTypes}
            entityTypeId={entityTypeId}
            onChange={(newEntityType) => {
              setEntitySelector?.(new EntitySelector.OfType(newEntityType.id))
            }}
            disabled={disabled}
          />
        </div>
      )}
      {entityTypeId && (
        <UnlabeledField style={{ flexShrink: 0 }}>
          <Checkbox
            size="sm"
            label="Filter"
            checked={filter}
            onChange={(event) => {
              const isChecked = event.currentTarget.checked
              if (!isChecked) {
                setEntitySelector?.(new EntitySelector.OfType(entityTypeId))
              }
              setFilter(isChecked)
            }}
          />
        </UnlabeledField>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        {entityTypeId && filter && (
          <FieldValueEqualsInput
            disabled={isDisabled}
            entityTypeId={entityTypeId}
            selector={entitySelector as EntitySelector.FieldValueEquals}
            setSelector={(newSelector) => {
              if (newSelector) setEntitySelector?.(newSelector)
            }}
          />
        )}
      </div>
    </Group>
  )
}

export default TargetSelectorInput
